// modified version of Select component from aui-react-components

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class SelectBox extends React.Component {

    handleChange = (e) => {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(e.target.value, e);
        }
    }

    handleFocus = (e) => {
        if (typeof this.props.onFocus === 'function') {
            this.props.onFocus(e);
        }
    }

    handleBlur = (e) => {
        if (typeof this.props.onBlur === 'function') {
            this.props.onBlur(e);
        }
    }

    renderMessage = () => {
        const {isValid, isInvalid, validMessage, invalidMessage, description} = this.props;
        if (isValid && validMessage) {
            return (<span className="aui-select__valid">{validMessage}</span>);
        }
        if (isInvalid && invalidMessage) {
            return (<span className="aui-select__error">{invalidMessage}</span>);
        }
        if (description) {
            return (<span className="aui-select__description">{description}</span>);
        }
        return false;
    }

    render() {
        const {name, value, disabled, isValid, isInvalid, options} = this.props;
        return(
            <div className={classnames(
                "aui-select ade-select-box",
                {
                    "is-disabled": disabled,
                    "is-valid": isValid,
                    "is-invalid": isInvalid
                }
            )}>
                <div className="aui-select__field">
                    <select className="aui-select__input" id={name} value={value} disabled={disabled} onChange={this.handleChange} onFocus={this.handleFocus} onBlur={this.handleBlur}>
                        {options.map((opt, i) => <option key={`opt_${i}`} value={opt.value}>{opt.label}</option>)}
                    </select>
                </div>
                {this.renderMessage()}
            </div>
        );
    }

}

SelectBox.propTypes = {
    name: PropTypes.string,
    value: PropTypes.any,
    disabled: PropTypes.bool,
    isValid: PropTypes.bool,
    isInvalid: PropTypes.bool,
    options: PropTypes.array,
    validMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    invalidMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func
};

export default SelectBox;
